import { AnalyticsEvent } from '../analytics-event';

export type SearchPerformedOrigin =
  | 'carousel'
  | 'banner'
  | 'home_filter'
  | 'metadata'
  | 'explore_catalog'
  | 'explore_experiences'
  | 'search_box'
  | 'filter_bar'
  | 'notification'
  | 'modal_filter'
  | 'challenge'
  | 'predictive_search'
  | 'search_history'
  | 'none';

type SearchPerformedEventProps = {
  facets: string[];
  has_results: boolean;
  search_origin: SearchPerformedOrigin;
  collection_id?: string;
};

export class SearchPerformedEvent implements AnalyticsEvent<SearchPerformedEventProps> {
  readonly name = 'search_performed';
  readonly props: SearchPerformedEventProps;

  constructor(props: SearchPerformedEventProps) {
    this.props = props;
  }
}
